import React from 'react';
import ReactDOM from 'react-dom';

import Skeleton1 from './skeleton1';
import Skeleton2 from './skeleton2';
import Skeleton3 from './skeleton3';
import Skeleton4 from './skeleton4';


export default class XyLoading extends React.Component{
    render(){

        /*loading动画类型*/
        let component;
        if( this.props.type == 'skeleton1' ) component = (<Skeleton1 />);
        if( this.props.type == 'skeleton2' ) component = (<Skeleton2 />);
        if( this.props.type == 'skeleton3' ) component = (<Skeleton3 />);
        if( this.props.type == 'skeleton4' ) component = (<Skeleton4 />);

        /*组件可见性*/
        let visibility = this.props.visibility ? 'block' : 'none' ;


        return (
            <div style={{display:visibility}}>
                {component}
            </div>
        )
    }
}

XyLoading.defaultProps = {
    visibility:true, // 组件可见性 默认可见
    type:'skeleton1', // 样式类型
};


// ReactDOM.render(
//     <XyLoading/>,
//     document.getElementById('app')
// )